import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateSolicitudPagoDirectoByID = () => {
  const [loadingUpdateSolicitudPagoDirectoById, setLoadingUpdateSolicitudPagoDirectoById] = useState(false);
  const [successUpdateSolicitudPagoDirectoById, setSuccessUpdateSolicitudPagoDirectoById] = useState(false);
  const [errorUpdateSolicitudPagoDirectoById, setErrorUpdateSolicitudPagoDirectoById] = useState(null);
  const [dataUpdateSolicitudPagoDirectoById, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updateSolicitudPagoDirectoById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingUpdateSolicitudPagoDirectoById(true);
    setSuccessUpdateSolicitudPagoDirectoById(false);
    setErrorUpdateSolicitudPagoDirectoById(null);

   
    apiRecord.updateSolicitudPagoDirectoIncapacidadTemporalByID(userId, formId, data)
      .then((res: any) => {
        setLoadingUpdateSolicitudPagoDirectoById(false);
        setSuccessUpdateSolicitudPagoDirectoById(true);
        setDataSolicitudPagoDirecto(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingUpdateSolicitudPagoDirectoById(false);
        setErrorUpdateSolicitudPagoDirectoById(err.response?.data);
      });
  };

  return {
    updateSolicitudPagoDirectoById,
    loadingUpdateSolicitudPagoDirectoById,
    successUpdateSolicitudPagoDirectoById,
    errorUpdateSolicitudPagoDirectoById,
    dataUpdateSolicitudPagoDirectoById
  };
};

export default useUpdateSolicitudPagoDirectoByID;
